import styled from './theme/styled.js';
import { token } from './theme/tokens.js';
import { CartItem } from './CartItem.js';
import { Bag } from './theme/icons.js';

/**
 * The cart's contents are a list, so they get list markup.
 *
 * `role="list"` looks redundant on a `<ul>`, but is not: Safari/VoiceOver drops
 * list semantics from any list styled with `list-style: none`, and the reset below
 * is unavoidable — `all: revert` from `styled.js` restores the UA's bullets and
 * 40px inline padding, which would otherwise show up inside the panel.
 */
const LineItemList = styled.ul(({ theme }) => ({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '45vh',
    overflowY: 'auto',
    overflowX: 'hidden',
}));

const LineItemListItem = styled.li(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    borderBottom: `solid 1px ${token(theme, 'color.borderFooter')}`,

    margin: `0 calc(-1 * clamp(${token(theme, 'space.panelPaddingHorizontal')}, 5%, 5px))`, // Let child element span full parent width to apply backgound/border
    padding: `${token(theme, 'space.mediumGap')} clamp(${token(theme, 'space.panelPaddingHorizontal')}, 5%, 5px)`, // Reset parent padding after margin change
}));

const EmptyItemList = styled.div(({ theme }) => ({
    margin: token(theme, 'space.largeGap'),
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: token(theme, 'space.smallGap'),
    textAlign: 'center',
}));

const DefaultItems = ({
    isLoading,
    onQuantityChange,
    onRemoveProduct,

    displayLineItems,
    hasValidPricing,
}) => {
    const isEmpty = displayLineItems?.length === 0;

    return <>
        {!isEmpty &&
            <LineItemList role="list">
                {displayLineItems.map((lineItem) =>
                    <LineItemListItem key={lineItem.key}>
                        <CartItem
                            isLoading={isLoading}
                            onQuantityChange={onQuantityChange}
                            onRemoveProduct={onRemoveProduct}

                            hasValidPricing={hasValidPricing}
                            lineItem={lineItem}
                        />
                    </LineItemListItem>)}
            </LineItemList>
        }
        {isEmpty && <EmptyItemList>
            <Bag />
            <h3>Your bag is empty.</h3>
            <p>Add a device to start knowing more about your car.</p>
        </EmptyItemList>}
    </>;
};

const CartItems = ({ children, ...props }) => children || <DefaultItems {...props} />;

// Compound component pattern; TODO: fix this
CartItems.Wrapper = LineItemList;
CartItems.Item = CartItem;

export default CartItems;
